import React, { ReactNode } from "react"

interface HeroProps {
  image: ReactNode
}

export const Hero = ({ image }: HeroProps) => (
  <div className="max-w-8xl mx-auto w-full overflow-hidden rounded-lg lg:rounded-2xl">
    {image}
  </div>
)
